import styled from 'styled-components';

import { ReactComponent as BaseIconClose } from 'assets/images/icon-close.svg';

export const Options = styled.ol``;

export const OptionsItem: any = styled.li`
  display: flex;
  align-items: center;
  height: 88px;
  padding: 0 31px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.bottomSheetOptions.borderItem};

  &:hover {
    background-color: ${({ theme }) => theme.bottomSheetOptions.hover};
  }
`;

OptionsItem.Icon = styled.span`
  font-size: 30px;
  margin-right: 23px;
`;

OptionsItem.Name = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const Header: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #dbdbdb;
  margin: 16px 16px 0;
`;

Header.Title = styled.h1`
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;
`;

Header.Close = styled.div``;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  box-shadow: 0 6px 10px 0 rgba(128, 98, 96, 0.16);
  background-color: #ffffff;
  border-radius: 100%;
  cursor: pointer;
`;

export const IconClose = styled(BaseIconClose)`
  width: 11px;
`;
